import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { ButtonBase } from './button-base';
var STYLES_ENABLED = {
  backgroundColor: 'var(--colors-whitelabel-button-primary-background)',
  ':focus': {
    border: 1,
    borderColor: 'var(--colors-whitelabel-button-primary-background-active)'
  },
  ':hover': {
    backgroundColor: 'var(--colors-whitelabel-button-primary-background-hover)'
  },
  ':active': {
    backgroundColor: 'var(--colors-whitelabel-button-primary-background-active)'
  }
};
var STYLES_DISABLED = {
  backgroundColor: 'var(--colors-whitelabel-button-background)'
};
function ButtonPrimary(props) {
  return jsx(ButtonBase, _extends({}, props, {
    sx: _objectSpread({
      color: 'grey.0'
    }, props.disabled ? STYLES_DISABLED : STYLES_ENABLED)
  }));
}
export { ButtonPrimary };